<template>
  <div>
    <div>
      <!--      <AllCategories class="gadget desktopView"></AllCategories>-->
      <CategoryDescriptionComponent
        class="gadget"
      ></CategoryDescriptionComponent>
    </div>
    <div class="sticky-content">
      <div v-if="tagArray.length > 0">
        <h6>🏷 相关标签</h6>
        <Tag id="sidebarTags" class="gadget" :tags="tagArray"></Tag>
      </div>
    </div>
  </div>
</template>

<script>
import Tag from "./TagComponent.vue";
// import AllCategories from "./AllCategories.vue";
import { mapState } from "vuex";
import CategoryDescriptionComponent from "./CategoryDescriptionComponent";

export default {
  data: function() {
    return {
      tagArray: [],
      activeUserArray: [],
      linkArray: []
    };
  },
  components: {
    // AllCategories,
    CategoryDescriptionComponent,
    Tag
  },
  computed: {
    ...mapState(["tagsUrl"])
  },
  mounted: function() {
    this.fetchTags();
  },
  methods: {
    fetchTags: function() {
      this.$axios.get(this.tagsUrl).then(response => {
        this.tagArray = response.data;
      });
    }
  }
};
</script>
